// El webhook clásico (Conexiones › Plataformas), sin React: qué dice «Probar» y si el webhook está pausado.
// Mismo criterio que la tarjeta del Centro de Alertas (`alerts_center/rules/webhookModel.js`), con claves
// propias: el clásico no importa nada del Centro (`alerts_center/__tests__/classicIsolation.test.js`).

export const TONE_OK = 'ok';
export const TONE_ERROR = 'error';
export const TONE_NEUTRAL = 'neutral';

export const PAUSED_DEAD_URL = 'DEAD_URL';

/**
 * Qué dice «Probar». El backend responde OK siempre que el POST salió, aunque el destino conteste 404 o 500:
 * lo que pasó viene en `data` (`success` = 2xx, `response_status_code`). Sin respuesta que juzgar
 * (`success` en null) sólo se dice que se envió.
 *
 * `{tone, key, code}`; `key` es una clave de `webhook_component`.
 */
export function testResult(response) {
    if (!response || response.status !== 'OK') {
        return {tone: TONE_ERROR, key: 'webhook_component.test_error', code: null};
    }
    const data = response.data && typeof response.data === 'object' ? response.data : null;
    if (!data || typeof data.success !== 'boolean') {
        return {tone: TONE_NEUTRAL, key: 'webhook_component.test_sent', code: null};
    }
    const code = typeof data.response_status_code === 'number' ? data.response_status_code : null;
    if (data.success) return {tone: TONE_OK, key: 'webhook_component.test_ok', code};
    return {tone: TONE_ERROR, key: failureKey(code), code};
}

function failureKey(code) {
    if (code === null) return 'webhook_component.test_fail_no_answer';
    if (code === 404 || code === 410) return 'webhook_component.test_fail_gone';
    if (code >= 400 && code < 500) return 'webhook_component.test_fail_rejected';
    return 'webhook_component.test_fail_server';
}

// Los rechazos del comando cuyo motivo viene en el texto: una validación («URL inválida», «No se pudo enviar
// información al webhook») o la falta de permiso. Los demás (red, sesión) van al texto propio.
const REASON_IN_TEXT = ['ERROR', 'NO_MODULE_ACCESS'];

/**
 * El error de «Probar» que vale mostrar: el motivo que escribió el backend (`raw_body`, no `error_message`, que
 * el `APIClient` rellena con un genérico); si no, `null` y se usa el texto propio.
 */
export function testErrorReason(response) {
    if (!response || response.status === 'OK' || !REASON_IN_TEXT.includes(response.error_code)) return null;
    const body = response.raw_body;
    return body && typeof body.error_message === 'string' && body.error_message ? body.error_message : null;
}

/** La pausa que manda `GET webhook-url/` (`paused`, `paused_reason`, `paused_on`), o `null` si no está pausado. */
export function pauseOf(data) {
    if (!data || !data.paused) return null;
    return {
        reasonKey: data.paused_reason === PAUSED_DEAD_URL
            ? 'webhook_component.paused_reason_dead_url'
            : 'webhook_component.paused_reason_no_success',
        on: data.paused_on || null,
    };
}

/**
 * ¿El backend reanudó el webhook? Lo reanuda un «Probar» que llega bien a la dirección GUARDADA, o guardar una
 * dirección distinta (`events/webhook_health.py`). Probar otra dirección sin guardarla no lo reanuda.
 */
export function resumedByTest(result, testedUrl, savedUrl) {
    return result.tone === TONE_OK && (testedUrl || '') === (savedUrl || '');
}

export function resumedBySave(newUrl, savedUrl) {
    return !!newUrl && (newUrl || '') !== (savedUrl || '');
}

export function formatPauseDate(isoDate, language) {
    if (!isoDate) return null;
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString(language || undefined, {day: 'numeric', month: 'long'});
}
